import component from './PhDiceSix.vue_vue_type_script_lang.vue.js';
export { default } from './PhDiceSix.vue_vue_type_script_lang.vue.js';
import { render } from './PhDiceSix.vue_vue_type_template_id_a717fa3e_lang.vue.js';

component.render = render;
